module.exports = __webpack_public_path__ + "static/media/i2.490ba97d.jpg";